<style lang="scss" >
.font-weight {
    font-weight: 800;
}
.inbound-package {
	right: 10px;
	top: 3px;
}
.reciveoffer .ivu-table{
    font-size: 12px !important;
}
.reciveoffer .ivu-table-cell{
    padding-left: 5px !important;
    padding-right: 5px !important;
}
.reciveoffer td.ivu-table-expanded-cell{
    padding: 0px !important;
}
.reciveoffer td.ivu-table-expanded-cell{
    padding: 0px !important;
    border: none !important
}

.reciveoffer td.ivu-table-expanded-cell .ivu-table-wrapper-with-border{
    border: none !important
}
.reciveoffer .workitemtable .ivu-table-border td:last-child{
        border-right: none !important;
    }
.reciveoffer {
    .wrapper-layout{
        margin-bottom: 10px !important;
    }
}
</style>
<template>
    <div class="reciveoffer margin-top-10">
        <div v-if="type=='query'" class="margin-bottom-10">
            <Button type="info" @click="queryLogData">查看历史版本</Button>
        </div>
        <div style="display:flex;height: 300px">
            <compWrapper title="基本信息"  :class="classes">
                <compFormEdit ref="relation" class="margin-layout" :formdata="getBase" v-model="formData" :labelWidth="120"/>
            </compWrapper>
            <compWrapper title="计费项目"  style="width:30%;margin-left:10px" v-if="(formData.expenseCategoryType==3)">
                <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll" style="padding-left:25%; margin:8px 0">全选</Checkbox>
                <CheckboxGroup v-if="this.type != 'query'" v-model="countDataList" @on-change="checkAllGroupChange" style="display:flex; flex-direction:column; align-items:flex-start; padding-left:25%; height:200px; overflow:auto">
                    <Checkbox v-for="(item,index) in countData" :key="index" :label="item.label" style="margin-bottom:8px"></Checkbox>
                </CheckboxGroup>

                <CheckboxGroup v-else v-model="countDataList" @on-change="checkqueryAllGroupChange" style="display:flex; flex-direction:column; align-items:flex-start; padding-left:25%; height:200px; overflow:auto">
                    <Checkbox v-for="(item,index) in countDataListQuery" :key="index" :label="item" style="margin-bottom:8px"></Checkbox>
                </CheckboxGroup>
            </compWrapper>
        </div>
        <!-- 价格列表 -->
        <compWrapper title="价格列表" >
            <!-- 针对仓储费展示提示 -->
            <Alert class="margin-15" v-if="formData.expenseCategoryType == 1" show-icon>
                计费时根据自上而下的优先级进行匹配，匹配到规则后，后续规则不再匹配，可手动调整排序修改优先级。
            </Alert>
            <div class="margin-left-15" v-if="formData.expenseCategoryType == 1 && type!='query'">
                <Button type="primary" @click="addItemStorage">新增</Button>
            </div>
            <div v-show="(formData.expenseCategoryType == 0)" class="margin-15">
                <Button v-if="isShowDetail" @click="showDetail">全部展开</Button>
                <Button v-else @click="showDetail">全部折叠</Button>
            </div>
            <!-- 作业费table -->
            <Table
            v-if="formData.expenseCategoryType == 0"
            style="z-index:2"
            class="margin-15 worktable"
            :columns="workcolumns"
            :data="workDataList"
            size="small"
            ref="tabledoc"
            max-height="500"
            :span-method="handleSpan"
            border></Table>

            <!-- 仓储费table -->
            <Table
            v-if="formData.expenseCategoryType == 1"
            class="margin-15"
            :columns="storagecolumns"
            :data="storageList"
            size="small"
            ref="storagetable"
            max-height="500"
            :draggable="isdraggable"
            @on-drag-drop="onDragDrop"
            border></Table>

            <!-- 其他table -->
            <vTable
            v-if="formData.expenseCategoryType == 3"
            style="z-index:2"
            class="margin-15"
            :columns="columns"
            :data="newDatalist"
            max-height="500"
            size="small"
            ref="tabledoc"
            border></vTable>

            <vButtonGroup v-if="type !=='query' && formData.expenseCategoryType != 1" class="absolute inbound-package">
                <vButton theme="success" @click="importExcel">导入</vButton>
                <vButton @click="exportExcel">导出</vButton>
            </vButtonGroup>
            <vButtonGroup v-if="type !=='query'" slot="footer">
                <Button type="primary" @click="submit">保存</Button>
                <Button class="margin-left-10" @click="cancel">取消</Button>
			</vButtonGroup>
        </compWrapper>
        <!-- 操作历史 -->
        <!-- <compWrapper title="操作历史" theme="gray" v-if="querytype=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper> -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" v-on="modalProps.on"></component>
        </compModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>

    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";

import {
    HttpGetBillingUnit,
    HttpGetAllBillingCondition,
} from '@/service/bespeak';

import { HttpQueryReciveBase, HttpQueryRecivePrice,HttpSaveReciveTemplate,HttpGetAllValuationList,HttpGetCategoryType,HttpGetQuerySubByIds,HttpGetStorageHistoryPriceItems,HttpSaveStorageReciveTemplate} from "@/service/tasks";
import { HttpQueryBillRuleOne } from "@/service/newbigaccount";
import compLogVersion from '../payableoffer/logversion.vue'
import compCategory from './category.vue'

import mixin from '../mixin';
export default {
    mixins: [mixin],
    props:['activeid','querytype'],
    data(){
        return {
            id:this.$route.query.id || this.activeid,
            type: this.$route.params.type || this.querytype,
            formData:{
                expenseCategoryType:-1,
            },
            modalProps:{
                show: false,
            },
            isdraggable:false,
            countData:[],
            countDataList:[],
            countDataListQuery:[],
            indeterminate: false,
            checkAll: false,
            logList:[],
            datalist:[],
            storageList:[],
            newDatalist:[],
            copyList:[],
            startAllTime: '',
            endAllTime: '',
            startWorkAllTime:'',
            endWorkAllTime:'',
            startStoraAllTime: '',
            endStoraAllTime:'',
            loading:false,
            showDate:'',
            billUnitEnum:[],
            billConditionEnum:[],
            valuationList:[],
            dataName:[],
            workDataList:[],
            isShowDetail: false,
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLogVersion,
        compCategory,
	},
    created(){
        this.update();
        if(this.type !='query'){
            this.isdraggable = true;
        }
        // 查询计费单位与附加条件
        HttpGetBillingUnit().then(res=>{
            Object.keys(res.data).forEach((key)=>{
                let jsonone = {
                    label:key,
                    value:res.data[key]
                }
                this.billUnitEnum.push(jsonone)
            })
        })
        HttpGetAllBillingCondition().then(res=>{
            this.billConditionEnum = res.data.map(item=>{
                return {
                    value:item.code,
                    label:item.name
                }
            })
        })
        HttpGetAllValuationList().then(res=>{
            this.valuationList = res.data.map(item=>{
                return {
                    value:item.id,
                    label:item.name+'('+item.code+')',
                    attach:{
                        code:item.code
                    }
                }
            })
            // console.log(this.valuationList,'valuationList')
        })


        this.showDate = this.type != 'query' ? 'flex':'none';
    },
    watch :{
        'countDataList': {
            handler(val) {
                this.changeNewDatalist(val);
            },
        }
    },
    computed:{
        ...mapGetters('dictionary', ['getCusBillTypeList']),
        ...mapGetters('common', ['getCurrencyList']),
        classes(){
            return {
                'width-100per':this.formData.expenseCategoryType==0 || this.formData.expenseCategoryType==1,
                'width-70per':this.formData.expenseCategoryType!=0
            }
        },
        getBase(){
            return [
                {
					label: "模板代码",
					key: "code",
                    query:true,
				},
                {
					label: "模板名称",
					key: "name",
                    query:this.type=='query',
				},
                {
                    label: "费用类型",
                    tag:'Select',
                    key:'expenseCategoryType',
                    options:this.getCusBillTypeList,
                    query:true,

                },
                {
                    label: "状态",
                    tag:'Select',
                    key:'status',
                    options:[
                        {value:0,label:'禁用'},
                        {value:1,label:'启用'},
                    ],
                    query:true,

                },
                {
                    label:'体积单位',
                    tag:'Select',
                    key:'unit',
                    options: [
                        { value: 0, label: '未定义' },
                        { value: 1, label: '立方英尺' },
                        { value: 2, label: '立方米' },
                    ],
                    show:this.formData.expenseCategoryType == 1,
                    query:true,
                },
                {
                    label: "计价方案",
                    tag:'Select',
                    key:'billingPlanId',
                    options:this.valuationList,
                    query:true,
                    show:this.formData.expenseCategoryType == 0,
                },
                {
                    label: "版本号",
                    tag:'Input',
                    key:'version',
                    query:true,

                },
                {
                    label: "备注",
                    tag:'Input',
                    key:'description',
                    query:this.type=='query',
                    required:false,

                },


            ]
        },
        columns(){
            let _this = this;
            return [
                {
                    title: 'code',
                    key: 'billingCategoryCode',
                },{
                    title: '计费项目',
                    key: 'billingCategoryName'
                }, {
                    title: '计费单位',
                    key: 'billingUnit',
                    render:(h,{ row, index })=>{
                        return <div>{this.getbillingUnit(row.billingUnit)}</div>
                    }

                }, {
                    title: '名称',
                    key:'description',
                },{
                    title: '规则分组',
                    key:'groupName',
                },
                {
                    title: '约束条件',
                    // key: 'billingCondition',
                    render:(h,{ row, index })=>{
                        if(row.billingCondition){
                            if(row.billingUnit == 900){
                                return <div>{row.billingCondition}</div>
                            }else{
                                return <div>{this.getbillConditionEnum(row.billingCondition) || '--' }</div>
                            }
                        }else{
                            return <div>--</div>
                        }
                    }

                },
                {
                    title: '公式',
                    key: 'billingCategoryFormula',
                    render:(h,{ row, index })=>{
                        return <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><Tooltip content={row.billingCategoryFormula}>{row.billingCategoryFormula}</Tooltip></div>
                    }
                },
                {
                    width:this.formData.expenseCategoryType == 3 ? 'auto':0,
                    title: '计费公式',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' ){
                            return <div>{row.formula}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.formula
                                },
                                on: {
                                    'input':(event) => {
                                        this.setValue(row,'formula',event)
                                    }
                                },
                            })
                        }
                    },
                },
                {
                    width:this.formData.expenseCategoryType == 1 ? '75':0,
                    title: '存储天数起',
                    render:(h,{ row, index })=>{
                        return <div>{row.attachValue}</div>
                    },
                },
                {
                    width:this.formData.expenseCategoryType == 1 ? '75':0,
                    title: '存储天数止',
                    render:(h,{ row, index })=>{
                        return <div>{row.attachValue1}</div>
                    },
                },

                {
                    title:'单价',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.price}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.price
                                },
                                on: {
                                    'input':(event) => {
                                        this.setValue(row,'price',event)
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最低收费',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.minimumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.minimumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        this.setValue(row,'minimumCharge',event)
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最高收费',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.maximumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.maximumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        this.setValue(row,'maximumCharge',event)
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    // title: "生效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','生效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('vDatepicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'datetime',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        format:'yyyy-mm-dd',
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                    'on-change':function(date,value){
                                        _this.startAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      type: "gray",
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setStartTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.startTime}</div>
                        }else{
                            return h('vDatepicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'datetime',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    // clearable:true,

                                    format:'yyyy-mm-dd',
                                    confirm: false,
                                    // value:_this.datalist[index].startTime
                                    value:  _this.datalist.filter(item => item.billingCategoryCode == row.billingCategoryCode)[0].startTime
                                },
                                on: {
                                    'on-change':function(date,value){
                                        // console.log(date,value,'startTime')
                                        _this.datalist.filter(item => {
                                            if(item.billingCategoryCode == row.billingCategoryCode){
                                                item.startTime = date
                                            }
                                        })
                                        // _this.datalist[index].startTime = date
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    // title: "失效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','失效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('vDatepicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'datetime',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        format:'yyyy-mm-dd',
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                        'on-change':function(date,value){
                                            _this.endAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setEndTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.endTime}</div>
                        }else{
                            return h('vDatepicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'datetime',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    // clearable:true,

                                    format:'yyyy-mm-dd',
                                    confirm: false,
                                    // value:_this.datalist[index].endTime
                                    value:  _this.datalist.filter(item => item.billingCategoryCode == row.billingCategoryCode)[0].endTime
                                },
                                on: {
                                    'on-change':function(date,value){
                                        _this.datalist.filter(item => {
                                            if(item.billingCategoryCode == row.billingCategoryCode){
                                                item.endTime = date
                                            }
                                        })
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    title:'创建人',
                    width: this.type == 'query' ? 60 : 0,
                    render:(h,{ row })=>{
                        return <div>{row.createdName}</div>
                    }
                },
                {
                    title:'创建时间',
                    width: this.type == 'query' ? 75 : 0,
                    render:(h,{ row })=>{
                        return <div>{row.createdAt}</div>
                    }
                },
                {
                    title:'更新人',
                    width: this.type == 'query' ? 60 : 0,
                    render:(h,{ row })=>{
                        return <div>{row.updatedName}</div>
                    }
                },
                // {
                //     title:'更新时间',
                //     width: this.type == 'query' ? 75 : 0,
                //     render:(h,{ row })=>{
                //         return <div>{row.updatedAt}</div>
                //     }
                // },
            ]
        },
        storagecolumns(){
            let _this = this;
            let stoList = [
                {
                    title: 'No',
                    type: 'index',
                    width:60,
                    align:'center'
                },
                {
                    title: '排序',
                    width:60,
                    align:'center',
                    render:(h,{ row, index })=>{
                        return <div>
                            <a><Tooltip content="可上下拖拽"><Icon style="font-size:26px" type="ios-hand-outline" /></Tooltip></a>
                        </div>
                    }
                },
                {
                    title: '操作',
                    align:'center',
                    width:70,
                    render:(h, { row, index })=>{
						return h('div', [
                            h('Button', {
                                props: {
                                    theme: "error",
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        this.delStorage(row,index)
                                    }
                                },
                            }, '删除')
                        ])
					}
                },
                {
                    title: '规则代码',
                    key: 'billingCategoryCode',
                },
                {
                    title: '规则名称',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.billingCategoryName}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.billingCategoryName
                                },
                                on: {
                                    'input':(event) => {
                                        // this.setStroValue(row,'billingCategoryName',event)
                                        _this.storageList[index].billingCategoryName = event
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title: '计费模式',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{this.StoBillingUnit(row.billingUnit)}</div>
                        }else{
                            return h('Select', {
                                    attrs: {
                                        value: _this.storageList[index].billingUnit,
                                    },
                                    props: {transfer: true, clearable: true},
                                    on: {
                                        'on-change': (value) => {
                                            this.storageList[index].billingUnit = value;
                                            if(value==11111 || value==22222){
                                                this.storageList[index].billingCondition = '';
                                                this.storageList[index].attachValue = '';
                                                this.storageList[index].attachValue1 = '';
                                                this.storageList[index].inboundStartDate = '';
                                                this.storageList[index].inboundEndDate = '';
                                            }
                                            if(value==200 || value==201){
                                                this.storageList[index].billingCategoryFormula = '';
                                            }
                                        }
                                    },
                                },
                                _this.billMode.map((json) => {
                                    return h('Option', {
                                        props:{
                                            label:json.label,
                                            value:json.value
                                        }
                                    });
                                })
                            )
                        }
                    }
                },
                {
                    title: '库存类型',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' || row.billingUnit=='11111' || row.billingUnit=='22222'){
                            return <div>{this.getBillStoCondition(row.billingCondition)}</div>
                        }else{
                            return h('Select', {
                                    attrs: {
                                        value: this.storageList[index].billingCondition,
                                    },
                                    props: {transfer: true, clearable: true},
                                    on: {
                                        'on-change': (value) => {
                                            this.storageList[index].billingCondition = value
                                        }
                                    },
                                },
                                _this.invenType.map((json) => {
                                    return h('Option', {
                                        props:{
                                            label:json.label,
                                            value:json.value
                                        }
                                    });
                                })
                            )
                        }
                    }
                },
                {
                    title: '存储天数起',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' || row.billingUnit=='11111' || row.billingUnit=='22222'){
                            return <div>{row.attachValue}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.attachValue
                                },
                                on: {
                                    'input':(event) => {
                                        // this.setStroValue(row,'attachValue',event)
                                        _this.storageList[index].attachValue = event
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title: '存储天数止',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' || row.billingUnit=='11111' || row.billingUnit=='22222'){
                            return <div>{row.attachValue1}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.attachValue1
                                },
                                on: {
                                    'input':(event) => {
                                        // this.setStroValue(row,'attachValue1',event)
                                        _this.storageList[index].attachValue1 = event
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'入库起始时间',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query' || row.billingUnit!='201'){
                            return <div>{row.inboundStartDate}</div>
                        }else{
                            return h('vDatepicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'datetime',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    format:'yyyy-mm-dd',
                                    confirm: false,
                                    value:_this.storageList[index].inboundStartDate
                                },
                                on: {
                                    'on-change':function(date,value){
                                        // console.log(date,value,'startTime')
                                        _this.storageList[index].inboundStartDate = date
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    title:'入库截止时间',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query' || row.billingUnit!='201'){
                            return <div>{row.inboundEndDate}</div>
                        }else{
                            return h('vDatepicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'datetime',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    format:'yyyy-mm-dd',
                                    confirm: false,
                                    value:_this.storageList[index].inboundEndDate
                                },
                                on: {
                                    'on-change':function(date,value){
                                        // console.log(date,value,'startTime')
                                        _this.storageList[index].inboundEndDate = date
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    title: '代码/规则编码',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' || row.billingUnit=='200' || row.billingUnit=='201'){
                            return <div>
                                <div style="white-space: nowrap;overflow:hidden;text-overflow: ellipsis;"><Tooltip max-width="250" content={row.billingCategoryFormula}>{row.billingCategoryFormula}</Tooltip></div>
                            </div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.billingCategoryFormula
                                },
                                on: {
                                    'input':(event) => {
                                        // this.setStroValue(row,'billingCategoryFormula',event)
                                        _this.storageList[index].billingCategoryFormula = event
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'单价',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.price}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.price
                                },
                                on: {
                                    'input':(event) => {
                                        // this.setStroValue(row,'price',event)
                                        _this.storageList[index].price = event
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最低收费',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.minimumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.minimumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        // this.setStroValue(row,'minimumCharge',event)
                                        _this.storageList[index].minimumCharge = event
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最高收费',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.maximumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.maximumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        // this.setStroValue(row,'maximumCharge',event)
                                        _this.storageList[index].maximumCharge = event
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    // title: "生效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','生效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('DatePicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'date',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                    'on-change':function(date,value){
                                        _this.startStoraAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      type: "gray",
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setStoraStartTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.startTime}</div>
                        }else{
                            return h('DatePicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'date',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    confirm: false,
                                    // value:_this.datalist[index].startTime
                                    value: row.startTime
                                },
                                on: {
                                    'on-change':function(date,value){

                                        _this.storageList[index].startTime = date
                                    },
                                },
                            })
                        }
                    }
                },

                {
                    // title: "失效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','失效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('DatePicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'date',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                        'on-change':function(date,value){
                                            _this.endStoraAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setStoraEndTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.endTime}</div>
                        }else{
                            return h('DatePicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'date',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    confirm: false,
                                    // value:_this.datalist[index].endTime
                                    value: row.endTime
                                },
                                on: {
                                    'on-change':function(date,value){

                                        _this.storageList[index].endTime = date
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    title:'创建人/创建时间',
                    width: this.type == 'query' ? 110 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.createdName}
                            <div>{row.createdAt}</div>
                        </div>
                    }
                },
                {
                    title:'更新人',
                    width: this.type == 'query' ? 70 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.updatedName}
                        </div>
                    }
                },
            ];
            if(this.type!='query'){
                return stoList.splice(0,17)
            }else{
                stoList.splice(1,2)
                return stoList
            }
        },
        workcolumns(){
            let _this = this;
            let worklist = [
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, {row}) => {
                            return <Table border class="font-12 workitemtable" columns={this.workItemcolumns} show-header={false} data={row.childrenArr||[]}></Table>
                        }
                    },

                {
                    title: '单据类型',
                    key: 'orderType',
                    render:(h,{row})=>{
                        let name = this.getOrderList.find( obj => obj.value === row.orderType)
                        return <div>{name.label}</div>
                    }
                },
                {
                    title: 'code/计费项目',
                    key: 'billingCategoryCode',
                    width:100,
                    render:(h,{row})=>{
                        return <div></div>
                    }
                }, {
                    title: '计费单位',
                    key: 'billingUnit',
                    render:(h,{ row, index })=>{
                        return <div></div>
                    }

                }, {
                    title: '名称',
                    key:'description',
                },{
                    title: '规则分组',
                    key:'groupName',
                },
                {
                    title: '约束条件/公式',
                    width:140,
                    render:(h,{ row, index })=>{
                        return <div></div>
                    }
                },
                {
                    title:'单价',
                    render:(h,{ row, index })=>{
                        return <div>{row.price}</div>
                    }
                },
                {
                    title:'最低收费',
                    render:(h,{ row, index })=>{
                        return <div>{row.minimumCharge}</div>
                    }
                },
                {
                    title:'最高收费',
                    render:(h,{ row, index })=>{
                        return <div>{row.maximumCharge}</div>
                    }
                },
                {
                    // title: "生效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','生效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('DatePicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'date',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                    'on-change':function(date,value){
                                        _this.startWorkAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      type: "gray",
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setWorkStartTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        return <div>{row.startTime}</div>
                    }
                },
                {
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','失效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('DatePicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'date',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                        'on-change':function(date,value){
                                            _this.endWorkAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setWorkEndTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        return <div>{row.endTime}</div>
                    }
                },
                {
                    title:'创建人/创建时间',
                    width: this.type == 'query' ? 110 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.createdName}
                            <div>{row.createdAt}</div>
                        </div>
                    }
                },
                {
                    title:'更新人',
                    width: this.type == 'query' ? 70 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.updatedName}
                        </div>
                    }
                },
            ]
            if(this.type!='query'){
                return worklist.splice(0,12)
            }else{
                return worklist
            }
        },
        workItemcolumns(){
            let _this = this;
            let workitemlist = [
                    {
                        type: 'index',
                        width: 50,
                        align:'center',
                    },
                {
                    title: '单据类型',
                    key: 'orderType',
                    render:(h,{row})=>{
                        return <div></div>
                    }
                },
                {
                    title: 'code/计费项目',
                    key: 'billingCategoryCode',
                    width:100,
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.billingCategoryCode || '--'}</div>
                            <div>{row.billingCategoryName || '--'}</div>
                        </div>
                    }
                }, {
                    title: '计费单位',
                    key: 'billingUnit',
                    render:(h,{ row, index })=>{
                        return <div>{this.getbillingUnit(row.billingUnit)}</div>
                    }

                }, {
                    title: '名称',
                    key:'description',
                },{
                    title: '规则分组',
                    key:'groupName',
                },
                {
                    title: '约束条件/公式',
                    width:140,
                    render:(h,{ row, index })=>{
                        let tiaojian;
                        if(row.billingCondition){
                            if(row.billingUnit == 900){
                                tiaojian = row.billingCondition
                            }else{
                                tiaojian = this.getbillConditionEnum(row.billingCondition) || '--'
                            }
                        }else{
                            tiaojian = '--'
                        }
                        return <div>
                            {tiaojian}
                            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><Tooltip content={row.billingCategoryFormula}>{row.billingCategoryFormula || '--'}</Tooltip></div>
                        </div>
                    }
                },
                {
                    title:'单价',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' || row.itemquery == 'query'){
                            return <div>{row.price}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.price
                                },
                                on: {
                                    'input':(event) => {
                                        row.price = event
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最低收费',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' || row.itemquery == 'query'){
                            return <div>{row.minimumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.minimumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        row.minimumCharge = event
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最高收费',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' || row.itemquery == 'query'){
                            return <div>{row.maximumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.maximumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        row.maximumCharge = event
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    // title: "生效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','生效日期'),
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.startTime}</div>
                        }else{
                            return h('DatePicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'date',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    confirm: false,
                                    // value:_this.datalist[index].startTime
                                    value:  row.startTime
                                },
                                on: {
                                    'on-change':function(date,value){
                                        row.startTime = date
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','失效日期')
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.type == 'query'){
                            return <div>{row.endTime}</div>
                        }else{
                            return h('DatePicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'date',
                                    style:'width:100%',
                                    placeholder:"Select date",

                                    confirm: false,
                                    value:  row.endTime
                                },
                                on: {
                                    'on-change':function(date,value){
                                        row.endTime = date
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })},
                                },
                            })
                        }
                    }
                },
                {
                    title:'创建人/创建时间',
                    width: this.type == 'query' ? 110 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.createdName}
                            <div>{row.createdAt}</div>
                        </div>
                    }
                },
                {
                    title:'更新人',
                    width: this.type == 'query' ? 70 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.updatedName}
                        </div>
                    }
                },
            ]
            if(this.type!='query'){
                return workitemlist.splice(0,12)
            }else{
                return workitemlist
            }
        }
    },
    methods:{
        // 新增仓储行
        addItemStorage(){
            let jsonone = {
                billingCategoryCode:'',
                billingCategoryName:'',
                billingUnit:'',
                billingCondition:'',
                attachValue:'',
                attachValue1:'',
                inboundStartDate:'',
                inboundEndDate:'',
                billingCategoryFormula:'',
                price:'',
                minimumCharge:'',
                maximumCharge:'',
                startTime:'',
                endTime:''
            }
            this.storageList.push(jsonone)
        },
        delStorage(row,index){
            this.storageList.splice(index,1)
        },
        // 仓储的拖转
        onDragDrop(first, end){
            first = parseInt(first)
            end = parseInt(end)

            let tmp = this.storageList[first]

            if(first < end) {
                for(var i=first+1; i<=end; i++) {
                    this.storageList.splice(i-1, 1, this.storageList[i])
                }
                this.storageList.splice(end, 1, tmp)
            }

            if(first > end) {
                for(var i=first; i>end; i--) {
                    this.storageList.splice(i, 1, this.storageList[i-1])
                }
                this.storageList.splice(end, 1, tmp)
            }
        },
        async showDetail(){
            this.loading = true;
            await setTimeout(()=>{
                this.workDataList.map(item=>{
                    item._expanded = !item._expanded
                })
                this.isShowDetail = !this.isShowDetail;
            },0);
            this.loading = false;
        },
        handleSpan({ row, column, rowIndex, columnIndex }){
            if(columnIndex === 1){
                return [1,15]
            }else if(columnIndex === 0){
                return [1,1]
            }else{
                return [0,0]
            }
        },
        // 查看历史版本
        queryLogData(){
            this.$emit('on-closeCloseable');
            this.modalProps = {
                title:'历史版本',
                show:true,
                component:'compLogVersion',
                code:this.formData.code,
                width:800,
                showFooter:false,
            }
        },
        // handleCategory(category){
        //     this.$emit('on-closeCloseable');
        //     this.modalProps = {
        //         title:'查看',
        //         show:true,
        //         component:'compCategory',
        //         category:category,
        //         width:500,
        //         showFooter:false,
        //     }
        // },
        closemodalprops(){
            this.modalProps = {};
            this.$emit('on-openCloseable');
        },
        async changeNewDatalist(val){
            this.loading = true
            await setTimeout(()=>{
                this.newDatalist = this.datalist.filter(item=>{
                    for( let i=0;i<val.length;i++){
                        if(item.billingCategoryName.split('-规')[0] == val[i])
                        return item
                    }
                })
                this.newDatalist.sort(this.dataSort)
            },0);
            this.loading = false
        },
        importExcel(){
            this.modalProps = {
                show: true,
                title: '导入数据',
                width:460,
                showFooter: false,
                action: process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billingPriceTemplateItem/importItems",
                name: "excelFile",
                component: "compUpload",
                data: {
                    id:this.id,
                    templateCode: this.formData.code,
                    contextId: global.SYSID
                },
                download: () => {
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/newBilling/billingPriceTemplateItem/itemTemplate',{
                        id:this.id,
                        contextId: global.SYSID
                    },'download')
                },
                on:{
                    'on-success':(res)=>{
                        this.modalProps={},
                        this.update();
                    }
                }
            }
        },
        exportExcel() {
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billingPriceTemplateItem/export", {templateCode:this.formData.code,version:this.formData.version}, 'download')
        },
        setStartTime(){
            if(this.startAllTime){
                this.newDatalist.map(item=>{
                    this.$set(item,'startTime',this.startAllTime)
                })
            }
        },
        setEndTime(){
            if(this.endAllTime){
                this.newDatalist.map(item=>{
                    this.$set(item,'endTime',this.endAllTime)
                })
            }
        },
        // 仓储table的日期操作
        setStoraStartTime(){
            if(this.startStoraAllTime){
                this.storageList.map(item=>{
                    this.$set(item,'startTime',this.startStoraAllTime)
                })
            }
        },
        setStoraEndTime(){
            if(this.endStoraAllTime){
                this.storageList.map(item=>{
                    this.$set(item,'endTime',this.endStoraAllTime)
                })
            }
        },
        setWorkStartTime(){
            if(this.startWorkAllTime){
                this.workDataList.map(item=>{
                    item.childrenArr.map(json=>{
                        item._expanded = true;
                        json.startTime = this.startWorkAllTime;
                        // this.$set(json,'startTime',this.startWorkAllTime)
                    })
                })
            }
        },
        setWorkEndTime(){
            if(this.endWorkAllTime){
                this.workDataList.map(item=>{
                    item.childrenArr.map(json=>{
                        this.$set(item,'_expanded',true)
                        this.$set(json,'endTime',this.endWorkAllTime)
                    })
                })
            }
        },
        setValue(obj,attr,value){
            this.datalist.map(item => {
                if(item.billingCategoryCode == obj.billingCategoryCode){
                    this.$set(item,attr,value);
                }
            })
        },
        setStroValue(obj,attr,value){
            this.storageList.map(item => {
                if(item.billingCategoryCode == obj.billingCategoryCode){
                    this.$set(item,attr,value);
                }
            })
        },
        dataSort(a,b){
            if( a.billingCategoryName !== b.billingCategoryName ) return a.billingCategoryName < b.billingCategoryName ? -1 : 1
            if( !a.groupName || !b.groupName ){
                return -1
            }else{
                if( a.groupName !== b.groupName ) return a.groupName < b.groupName ? -1 : 1
                else if( a.code !== b.code ) return a.code < b.code ? -1 : 1
            }
        },
        handleCheckAll () {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;
            if (this.checkAll) {
                if(this.type == 'query'){
                    this.countDataList = this.countDataListQuery
                }else{
                    this.countDataList = this.countData.map(item=>{return item.label});
                    this.checkAllGroupChange(this.countDataList)
                }
            } else {
                this.countDataList = [];
            }
        },
        checkAllGroupChange(data){
            let ids = []
            this.dataName.map(item=>{
                data.map(json=>{
                    if(item.label == json){
                        ids.push(item.value)
                    }
                })
            })

            // 点击获取对应的计费id子节点
            HttpGetQuerySubByIds({ids}).then(res=>{

                this.datalist = res.data.map(item=>{
                    item.billingCategoryCode = item.code;
                    item.billingCategoryName = item.name;
                    item.billingCategoryFormula = item.formula;
                    item.formula = item.formulaDefault;
                    item.billingCategoryId = item.id;
                    item.currentStatus = 0;
                    delete item.id
                    return item
                })
                let brr = [];
                brr = this.copyList.concat()
                this.datalist.map(json=>{
                    brr.map(item=>{
                        if(item.billingCategoryCode == json.code){
                            json.formula = item.formula;
                            json.price = item.price;
                            json.maximumCharge = item.maximumCharge;
                            json.minimumCharge = item.minimumCharge;
                            json.startTime = item.startTime;
                            json.endTime = item.endTime;
                        }
                    })
                })

                this.newDatalist = this.datalist
            })
        },
        checkqueryAllGroupChange(data){
            if (data.length === this.countDataListQuery.length) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        getbillingUnit(num){
            return this.billUnitEnum.filter(item=>{ return item.value === num })[0].label || '--'
        },
        StoBillingUnit(num){
            let one = this.billMode.filter(item=>{ return item.value == num})[0]
            return one.label
        },
        getBillStoCondition(num){
            let one = this.invenType.filter(item=>{ return item.value == num})[0]
            if(one){
                return one.label
            }
        },
        getbillConditionEnum(num){
            // console.log(num)
            if(num == 0){
                return '--'
            }else{
                let oneData = this.billConditionEnum.filter(item=>{ return item.value == num })
                if(oneData.length>0){
                    return oneData[0].label
                }else{
                    return '--'
                }
            }
        },
        update(){
            this.loading = true;
            this.$nextTick(() => {
                this.$refs.formbase.resetValidate();
            });
            HttpQueryReciveBase({
                    id:this.id,
            }).then(res=>{
                    this.formData = res.data;
                    // 请求仓储的table内容
                    if(this.formData.expenseCategoryType == 1){
                        HttpGetStorageHistoryPriceItems({
                            templateCode:res.data.code,
                            version:res.data.version
                        }).then(res=>{
                            this.loading = false;
                            this.storageList = res.data;
                        },err=>{

                        })
                    }else{
                        // 请求其他table内容
                        HttpQueryRecivePrice({
                            templateCode:res.data.code,
                            version:res.data.version
                        }).then(res=>{
                            this.checkAll = this.type == 'query'?true:false;
                            this.datalist = res.data.map(item=>{
                                return item
                            })
                            this.newDatalist = this.datalist
                            this.copyList = res.data;
                            // 作业费转换成其他数组形式
                            let obj = {};
                            this.datalist.forEach((item, index) => {
                                let { orderType } = item;
                                if (!obj[orderType]) {
                                    obj[orderType] = {
                                        orderType,
                                        itemquery:'query',
                                        billingCategoryCode:'',
                                        billingCategoryName:'',
                                        billingUnit:'',
                                        description:'',
                                        groupName:'',
                                        billingCondition:'',
                                        billingCategoryFormula:'',
                                        price:'',
                                        minimumCharge:'',
                                        maximumCharge:'',
                                        childrenArr: [],
                                        _expanded:true
                                    }
                                }
                                obj[orderType].childrenArr.push(item);
                            });
                            this.workDataList = Object.values(obj); // 最终输出


                            const dataName = res.data.map(item => {
                                return item.billingCategoryName.split('-规')[0]
                            });
                            this.countDataListQuery = dataName.filter( (item,index) => {
                                return dataName.indexOf(item) === index
                            })
                            this.countDataListQuery.sort()

                            this.countDataList = dataName.filter( (item,index) => {
                                return dataName.indexOf(item) === index
                            })

                            this.loading = false;
                        },err=>{
                            this.$Message.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        })

                    }

                    HttpGetCategoryType({expenseCategoryType:this.formData.expenseCategoryType,billingChannel:this.$route.name == 'tasksPayableofferUpdate'?1:0}).then(res=>{
                        this.dataName = res.data.map(item => {
                            return {
                                label:item.name,
                                value:item.id
                            }
                        });
                        this.countData = this.dataName.filter( (item,index) => {
                            return this.dataName.indexOf(item) === index
                        })
                        this.countData.sort()
                        const selectedName = res.data.filter(item=> item.status == 1).map(item => {
                            return item.billingCategoryName.split('-规')[0]
                        });
                    })
                },err=>{
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
            })

        },
        async submit(params){
            let flag = false
            await this.$refs.relation.validate(valid => {
                if (!valid) return flag = true
            })
            if (flag) return this.$Message.error('请填写必填项');

            // 判断是作业费还是仓储增值费
            let lastList = [];
            if(this.formData.expenseCategoryType == 0){
                this.workDataList.map(item=>{
                    lastList.push(...item.childrenArr)
                })
                let priceflag = false;
                let errorflag = false;
                let numflag = false;
                let dateflag = false;
                let costflag = false;
                // 判断填写了单价，当前行的日期必填
                for(let i=0;i<lastList.length;i++){
                    if(lastList[i].price&&lastList[i].price!=0){
                        if(!lastList[i].startTime || !lastList[i].endTime){
                            priceflag = true
                        }
                    }
                    if(lastList[i].price<0 || lastList[i].minimumCharge<0 || lastList[i].maximumCharge<0){
                        errorflag = true
                    }
                    if (lastList[i].price&&!(/[0-9]/g.test(lastList[i].price)) || lastList[i].minimumCharge&&!(/[0-9]/g.test(lastList[i].minimumCharge)) || lastList[i].maximumCharge&&!(/[0-9]/g.test(lastList[i].maximumCharge))){
                        numflag = true
                    }
                    if (new Date(lastList[i].endTime).getTime() < new Date(lastList[i].startTime).getTime()) {
                        dateflag = true
                    }
                    if (lastList[i].maximumCharge < lastList[i].minimumCharge ) {
                        costflag = true
                    }
                }
                if(priceflag){
                    this.$Message.error('填写单价行的日期必填！');
                    return
                }
                if(errorflag){
                    this.$Message.error('填写行的 单价 或 最低收费 或 最高收费 不能小于0！');
                    return
                }
                if(numflag){
                    this.$Message.error('填写行的 单价 或 最低收费 或 最高收费 只能填写数字！');
                    return
                }
                if(dateflag){
                    this.$Message.error('填写行的失效日期需 大于 生效日期！');
                    return
                }
                if(costflag){
                    this.$Message.error('填写行的最高收费需 大于 最低收费！');
                    return
                }
            // 判断为仓储费的时候
            }else if(this.formData.expenseCategoryType == 1){
                let priceflag = false;
                let errorflag = false;
                let numflag = false;
                let dateflag = false;
                let costflag = false;
                // 新增判断库存类型、存储天数起止、入库起止日期
                let inventypefalg = false;
                let storageflag = false;
                let storagebigsmall = false;
                let inboundflag = false;

                console.log(this.storageList,'this.storageListthis.storageList')
                // 判断填写了单价，当前行的日期必填
                for(let i=0;i<this.storageList.length;i++){
                    if(this.storageList[i].price&&this.storageList[i].price!=0){
                        if(!this.storageList[i].startTime || !this.storageList[i].endTime){
                            priceflag = true
                        }
                    }
                    if(this.storageList[i].price<0 || this.storageList[i].minimumCharge<0 || this.storageList[i].maximumCharge<0){
                        errorflag = true
                    }
                    if (this.storageList[i].price&&!(/[0-9]/g.test(this.storageList[i].price)) || this.storageList[i].minimumCharge&&!(/[0-9]/g.test(this.storageList[i].minimumCharge)) || this.storageList[i].maximumCharge&&!(/[0-9]/g.test(this.storageList[i].maximumCharge))){
                        numflag = true
                    }
                    if (new Date(this.storageList[i].endTime).getTime() < new Date(this.storageList[i].startTime).getTime()) {
                        dateflag = true
                    }
                    if (this.storageList[i].maximumCharge < this.storageList[i].minimumCharge ) {
                        costflag = true
                    }

                    if(this.storageList[i].billingUnit == 200 || this.storageList[i].billingUnit == 201){
                        console.log(this.storageList[i].billingCondition,'this.storageList[i].billingCondition')
                        if(!this.storageList[i].billingCondition){
                            inventypefalg = true;
                        }
                        if(!this.storageList[i].attachValue || !this.storageList[i].attachValue1){
                            storageflag = true;
                        }
                    }
                    if(this.storageList[i].billingUnit == 201){
                        if(!this.storageList[i].inboundStartDate && !this.storageList[i].inboundEndDate){
                            inboundflag = true;
                        }
                        if (this.storageList[i].inboundEndDate&&this.storageList[i].inboundStartDate&&(new Date(this.storageList[i].inboundEndDate).getTime() < new Date(this.storageList[i].inboundStartDate).getTime())) {
                            storagebigsmall = true
                        }
                    }
                }
                if(priceflag){
                    this.$Message.error('填写单价行的日期必填');
                    return
                }
                if(errorflag){
                    this.$Message.error('填写行的 单价 或 最低收费 或 最高收费 不能小于0');
                    return
                }
                if(numflag){
                    this.$Message.error('填写行的 单价 或 最低收费 或 最高收费 只能填写数字！');
                    return
                }
                if(dateflag){
                    this.$Message.error('填写行的失效日期需 大于 生效日期！');
                    return
                }
                if(costflag){
                    this.$Message.error('填写行的最高收费需 大于 最低收费！');
                    return
                }
                // 新增判断库存类型、存储天数起止、入库起止日期
                if(inventypefalg){
                    this.$Message.error('库存类型不能为空！');
                    return
                }
                if(storageflag){
                    this.$Message.error('存储天数起止不能为空！');
                    return
                }
                if(inboundflag){
                    this.$Message.error('入库起止日期不能为空，至少填写其一！');
                    return
                }
                if(storagebigsmall){
                    this.$Message.error('入库截止时间需 大于 入库起始时间！');
                    return
                }
                lastList = this.storageList;
            }
            else{
                this.datalist.map(item=>{
                    if(this.countDataList.indexOf(item.billingCategoryName.split('-规')[0]) > -1){
                        item.status = 1
                    } else{
                        item.status = 0
                    }
                    return item
                })

                let priceflag = false;
                let errorflag = false;
                let numflag = false;
                let dateflag = false;
                let costflag = false;
                // 判断填写了单价，当前行的日期必填
                for(let i=0;i<this.datalist.length;i++){
                    if(this.datalist[i].price&&this.datalist[i].price!=0){
                        if(!this.datalist[i].startTime || !this.datalist[i].endTime){
                            priceflag = true
                        }
                    }
                    if(this.datalist[i].price<0 || this.datalist[i].minimumCharge<0 || this.datalist[i].maximumCharge<0){
                        errorflag = true
                    }
                    if (this.datalist[i].price&&!(/[0-9]/g.test(this.datalist[i].price)) || this.datalist[i].minimumCharge&&!(/[0-9]/g.test(this.datalist[i].minimumCharge)) || this.datalist[i].maximumCharge&&!(/[0-9]/g.test(this.datalist[i].maximumCharge))){
                        numflag = true
                    }
                    if (new Date(this.datalist[i].endTime).getTime() < new Date(this.datalist[i].startTime).getTime()) {
                        dateflag = true
                    }
                    if (this.datalist[i].maximumCharge < this.datalist[i].minimumCharge ) {
                        costflag = true
                    }
                }
                if(priceflag){
                    this.$Message.error('填写单价行的日期必填');
                    return
                }
                if(errorflag){
                    this.$Message.error('填写行的 单价 或 最低收费 或 最高收费 不能小于0');
                    return
                }
                if(numflag){
                    this.$Message.error('填写行的 单价 或 最低收费 或 最高收费 只能填写数字！');
                    return
                }
                if(dateflag){
                    this.$Message.error('填写行的失效日期需 大于 生效日期！');
                    return
                }
                if(costflag){
                    this.$Message.error('填写行的最高收费需 大于 最低收费！');
                    return
                }
                lastList = this.datalist
            }

            this.loading = true;
            // console.log(lastList,'lastListlastList')
            // return
            // 保存存储页面
            if(this.formData.expenseCategoryType == 1){
                HttpSaveStorageReciveTemplate({
                    ...this.formData,
                    priceTemplateItems:lastList
                }).then(res=>{
                    this.$Message.success('保存成功');
                    this.cancel()
                    this.loading = false;
                },err=>{
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                    this.loading = false;
                })
            }else{
                HttpSaveReciveTemplate({
                    ...this.formData,
                    priceTemplateItems:lastList
                }).then(res=>{
                    this.$Message.success('保存成功');
                    this.cancel()
                    this.loading = false;
                },err=>{
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                    this.loading = false;
                })
            }
        },

        cancel(){
            if(this.$route.name == 'tasksReceiveofferUpdate'){
                this.$router.push({
                    name: 'tasksReceiveoffer',
                })
            }else{
                this.$router.push({
                    name: 'tasksPayableoffer',
                })
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.other-form {
    .form-item {
        height: 42px;
        margin-bottom: 5px;
        clear: both;
    }
}
</style>

